import { fetchData } from '../utils/netUtils';
import {
  checkifEmptyObject,
  removeEmptyKeys
} from '../utils/objectUtils';
import { resolveCurrentEnvironment } from '../utils/configUtils';

const FILTERS_MAPPER = {
};

const unityProfileService = {

  createUserProfile: async (tokenData, profileData) => {
    const currentENV = resolveCurrentEnvironment();
    const URL = `${currentENV.TBX_UNITY_API}/profiles`;
    const body = {
      name: profileData.name,
      max_rating: profileData.maxRating,
      props: {
       ...profileData.props
      }
    };
    const options = {
      credentials: 'include',
      method: 'POST',
      headers: {
        Accept: 'application/json',
        Authorization: `${tokenData['auth_type']} ${tokenData['access_token']}`,
        'Content-Type': 'application/json;charset=utf-8'
      },
      body: JSON.stringify(body)
    };

    return fetchData(URL, options);
  },

  deleteUserProfile: async (tokenData, profileID) => {
    const currentENV = resolveCurrentEnvironment();
    const URL = `${currentENV.TBX_UNITY_API}/profiles/${profileID}`;
    const options = {
      credentials: 'include',
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        Authorization: `${tokenData['auth_type']} ${tokenData['access_token']}`,
        'Content-Type': 'application/json;charset=utf-8'
      },
    };

    return fetchData(URL, options);
  },

  getClientAvatars: async (tokenData) => {
    const currentENV = resolveCurrentEnvironment();
    const URL = `${currentENV.TBX_UNITY_API}/profiles/avatars`;
    const options = {
      credentials: 'include',
      method: 'GET',
      headers: {
        Accept: 'application/json',
        Authorization: `${tokenData['auth_type']} ${tokenData['access_token']}`,
        'Content-Type': 'application/json;charset=utf-8'
      },
    };

    return fetchData(URL, options);
  },

  getUserProfiles: async (tokenData, profileID = null, create = false) => {
    const currentENV = resolveCurrentEnvironment();
    let URL = `${currentENV.TBX_UNITY_API}/profiles`;

    if(create){
      URL += '?create=true'
    }

    const options = {
      credentials: 'include',
      method: 'GET',
      headers: {
        Accept: 'application/json',
        Authorization: `${tokenData['auth_type']} ${tokenData['access_token']}`,
        'Content-Type': 'application/json;charset=utf-8'
      },
    };

    if (profileID) {
      URL += `/${profileID}`;
    }

    return fetchData(URL, options);
  },

  setCurrentProfile: async (tokenData, profileID, filters) => {
    const currentENV = resolveCurrentEnvironment();
     let URL = `${currentENV.TBX_UNITY_API}/profiles/${profileID}/current`;
     const options = {
      credentials: 'include',
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        Authorization: `${tokenData['auth_type']} ${tokenData['access_token']}`,
        'Content-Type': 'application/json;charset=utf-8'
      }
    };

    const filtersToQs = removeEmptyKeys(filters);
    if (filtersToQs && !checkifEmptyObject(filtersToQs)) {
      let qs =  Object.keys(filtersToQs).map((key) => {
        const qsKey = FILTERS_MAPPER[key] || key;

        if (typeof(filters[key]) === 'boolean') {
          return encodeURIComponent(qsKey);
        }
        return encodeURIComponent(qsKey) + '=' + encodeURIComponent(filters[key])
      }).join('&');

      URL += `?${qs}`;
    }

    return fetchData(URL, options);
  },

  updateUserProfile: async (tokenData, profileID, updatedData) => {
    const currentENV = resolveCurrentEnvironment();
    const URL = `${currentENV.TBX_UNITY_API}/profiles/${profileID}`;
    const body = {
      name: updatedData.name,
      max_rating: updatedData.maxRating,
      props: {
        ...updatedData.props
       }
    };
    const options = {
      credentials: 'include',
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        Authorization: `${tokenData['auth_type']} ${tokenData['access_token']}`,
        'Content-Type': 'application/json;charset=utf-8'
      },
      body: JSON.stringify(body)
    };

    return fetchData(URL, options);
  },

  getContentByProfile: async (tokenData, contentID, profileID) => {
    const currentENV = resolveCurrentEnvironment();
    const URL = `${currentENV.TBX_UNITY_API}/profiles/${profileID}/contents/${contentID}`;

    const options = {
      credentials: 'include',
      method: 'GET',
      headers: {
        Accept: 'application/json',
        Authorization: `${tokenData['auth_type']} ${tokenData['access_token']}`,
        'Content-Type': 'application/json;charset=utf-8'
      },
    };

    return fetchData(URL, options);
  },

  getCurrentContentPositionByProfile: async (tokenData, contentID, profileID) => {
    const currentENV = resolveCurrentEnvironment();
    const URL = `${currentENV.TBX_UNITY_API}/profiles/${profileID}/contents/${contentID}/bookmark`;

    const options = {
      credentials: 'include',
      method: 'GET',
      headers: {
        Accept: 'application/json',
        Authorization: `${tokenData['auth_type']} ${tokenData['access_token']}`,
        'Content-Type': 'application/json;charset=utf-8'
      },
    };

    return fetchData(URL, options);
  },

  getFavoriteContentsByProfile: async (tokenData, profileID) => {
    const currentENV = resolveCurrentEnvironment();
    const URL = `${currentENV.TBX_UNITY_API}/profiles/${profileID}/lists/favorites/contents`;

    const options = {
      credentials: 'include',
      method: 'GET',
      headers: {
        Accept: 'application/json',
        Authorization: `${tokenData['auth_type']} ${tokenData['access_token']}`,
        'Content-Type': 'application/json;charset=utf-8'
      }
    };

    return fetchData(URL, options);
  },

  addFavoriteContentByProfile: async (tokenData, profileID, contentID) => {
    const currentENV = resolveCurrentEnvironment();
    const URL = `${currentENV.TBX_UNITY_API}/profiles/${profileID}/lists/favorites/contents/${contentID}`;

    const options = {
      credentials: 'include',
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        Authorization: `${tokenData['auth_type']} ${tokenData['access_token']}`,
        'Content-Type': 'application/json;charset=utf-8'
      }
    };

    return fetchData(URL, options);
  },

  deleteFavoriteContentByProfile: async (tokenData, profileID, contentID) => {
    const currentENV = resolveCurrentEnvironment();
    const URL = `${currentENV.TBX_UNITY_API}/profiles/${profileID}/lists/favorites/contents/${contentID}`;

    const options = {
      credentials: 'include',
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        Authorization: `${tokenData['auth_type']} ${tokenData['access_token']}`,
        'Content-Type': 'application/json;charset=utf-8'
      }
    };

    return fetchData(URL, options);
  },

  addPinCodeProfile: async (tokenData, currenProfileID, targetProfile, newPin) => {
    const currentENV = resolveCurrentEnvironment();
    const URL = `${currentENV.TBX_UNITY_API}/profiles/${currenProfileID}/pin?newpin=${newPin}&targetprofile=${targetProfile}`;

    const options = {
      credentials: 'include',
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        Authorization: `${tokenData['auth_type']} ${tokenData['access_token']}`,
        'Content-Type': 'application/json;charset=utf-8'
      }
    };

    return fetchData(URL, options);
  },

  deletePinCodeProfile: async (tokenData, profileID) => {
    const currentENV = resolveCurrentEnvironment();
    const URL = `${currentENV.TBX_UNITY_API}/profiles/${profileID}/pin`;

    const options = {
      credentials: 'include',
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        Authorization: `${tokenData['auth_type']} ${tokenData['access_token']}`,
        'Content-Type': 'application/json;charset=utf-8'
      }
    };

    return fetchData(URL, options);
  },

  validateCurrentPinCodeProfile: async (tokenData, profileID, pin) => {
    const currentENV = resolveCurrentEnvironment();
    const URL = `${currentENV.TBX_UNITY_API}/profiles/${profileID}/pin?pin=${pin}`;

    const options = {
      credentials: 'include',
      method: 'GET',
      headers: {
        Accept: 'application/json',
        Authorization: `${tokenData['auth_type']} ${tokenData['access_token']}`,
        'Content-Type': 'application/json;charset=utf-8'
      }
    };

    return fetchData(URL, options);
  },

  updateProfileNotificationTopicsToken: async (tokenData, profileID, data) => {
    const currentENV = resolveCurrentEnvironment();
    const URL = `${currentENV.TBX_UNITY_API}/profiles/${profileID}/topic`;
    const body = {
     token: data.firebaseToken
    };

    const options = {
      credentials: 'include',
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        Authorization: `${tokenData['auth_type']} ${tokenData['access_token']}`,
        'Content-Type': 'application/json;charset=utf-8'
      },
      body: JSON.stringify(body)
    };

    return fetchData(URL, options);
  },

  subscribeToTopic: async (tokenData, profileID, topicID, topicType, data) => {
    const currentENV = resolveCurrentEnvironment();
    const URL = `${currentENV.TBX_UNITY_API}/profiles/${profileID}/topic/${topicID}/type/${topicType}`;
    const body = {
     expires: data.expires,
     startDate: data.startDate,
     token: data.firebaseToken
    };

    const options = {
      credentials: 'include',
      method: 'POST',
      headers: {
        Accept: 'application/json',
        Authorization: `${tokenData['auth_type']} ${tokenData['access_token']}`,
        'Content-Type': 'application/json;charset=utf-8'
      },
      body: JSON.stringify(body)
    };

    return fetchData(URL, options);
  },

};

export default unityProfileService;
